//import firebase from 'firebase';
import firebase from 'firebase/app';
import "firebase/auth";
import "firebase/firestore";
import 'firebase/messaging';

//Old db
// const config = {
//     apiKey: "AIzaSyAPn9ZMYOymOUMv__Z2spx2piaO52NFEy0",
//     authDomain: "mprocesses-test.firebaseapp.com",
//     databaseURL: "https://mprocesses-test.firebaseio.com",
//     projectId: "mprocesses-test",
//     storageBucket: "mprocesses-test.appspot.com",
//     messagingSenderId: "1:125630779589:android:cd44472b4f03fab1ae20ac"
// };

//Stage db
const config = {
    apiKey: "AIzaSyDpSZgMhM6dJIOqbCpFXfo2G1GjMmJkTMU",
    authDomain: "mprocesses-fb-stage.firebaseapp.com",
    projectId: "mprocesses-fb-stage",
    storageBucket: "mprocesses-fb-stage.appspot.com",
    messagingSenderId: "739250452179",
    appId: "1:739250452179:web:697836432ea6d50ec44626",
    measurementId: "G-4LXPP54BYS"
};

//Production db
// const config = {
//     apiKey: "AIzaSyDGXPpqqRyiMvxyiXN_PUain3RY_6MUCCE",
//     authDomain: "mprocesses-fb-prod.firebaseapp.com",
//     projectId: "mprocesses-fb-prod",
//     storageBucket: "mprocesses-fb-prod.appspot.com",
//     messagingSenderId: "1079770724232",
//     appId: "1:1079770724232:web:2b017022e3019563b36c3d",
//     measurementId: "G-HDGG9FND86"
// };

firebase.initializeApp(config);


// const messaging = firebase.messaging();
// try {
//     messaging.requestPermission()
//         .then((result) => {
//             console.log(result);
//             messaging.getToken({ vapidKey: "BGyx-LLMDzrq4UwPzsGK7ch39M-XajwKReuAoD0iAh3bB2L8LqXPta8ACU2Crxv51bsqaJRVnPdxcg0tcZWXYMk" })
//                 .then((result) => {
//                     console.log(result);
//                 })
//                 .catch(error => {
//                     messaging.requestPermission()
//                         .then((result) => {
//                             console.log(result);
//                             messaging.getToken({ vapidKey: "BGyx-LLMDzrq4UwPzsGK7ch39M-XajwKReuAoD0iAh3bB2L8LqXPta8ACU2Crxv51bsqaJRVnPdxcg0tcZWXYMk" })
//                                 .then((result) => {
//                                     console.log(result);
//                                 })
//                         })
//                 })
//         })

// }
// catch (error) {
//     messaging.getToken({ vapidKey: "BGyx-LLMDzrq4UwPzsGK7ch39M-XajwKReuAoD0iAh3bB2L8LqXPta8ACU2Crxv51bsqaJRVnPdxcg0tcZWXYMk" }).then((result) => {
//         console.log(result);
//     });
// }

// const fcmToken = await messaging.getToken({ vapidKey: "BMAmRh5yw80NHoUnMDGT0PMagj4ICNoudwCisfndU3LpHexZvjKPHLRgWpjIbpk5PxVpyfK8MYxbCbMCvvONIUo" });


const db = firebase.firestore();
export { db, firebase };